import PropTypes from 'prop-types'
import React from 'react'
import {Box, Button, Dialog} from '@chakra-ui/react3'

const ConfirmationModal = ({
    open,
    onOpenChange,
    onExitComplete,
    title,
    body,
    primaryActionLabel,
    secondaryActionLabel,
    onPrimaryAction,
    onSecondaryAction,
    placement
}) => {
    return (
        <Dialog.Root
            placement={placement}
            size={'sm'}
            scrollBehavior="inside"
            open={open}
            onOpenChange={onOpenChange}
            onExitComplete={onExitComplete}
        >
            <Dialog.Backdrop>
                <Dialog.Positioner>
                    <Dialog.Content>
                        <Dialog.Header>
                            <Dialog.Title as="h1">{title}</Dialog.Title>
                        </Dialog.Header>

                        {body && <Dialog.Body>{body}</Dialog.Body>}

                        <Dialog.Footer>
                            <Button
                                variant="secondaryFilled"
                                size="sm"
                                flex="1 0 0"
                                onClick={onPrimaryAction}
                            >
                                <Box as="span">{primaryActionLabel}</Box>
                            </Button>

                            <Button
                                variant="secondaryOutline"
                                size="sm"
                                flex="1 0 0"
                                onClick={onSecondaryAction}
                            >
                                <Box as="span">{secondaryActionLabel}</Box>
                            </Button>
                        </Dialog.Footer>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Dialog.Backdrop>
        </Dialog.Root>
    )
}

ConfirmationModal.propTypes = {
    open: PropTypes.bool,
    onOpenChange: PropTypes.func,
    onExitComplete: PropTypes.func,
    title: PropTypes.node,
    body: PropTypes.node,
    primaryActionLabel: PropTypes.node,
    secondaryActionLabel: PropTypes.node,
    onPrimaryAction: PropTypes.func,
    onSecondaryAction: PropTypes.func,
    placement: PropTypes.oneOf(['center', 'bottom'])
}

export default ConfirmationModal
